import http from '../common/http-common';
import { ActualizarContrasenaDto } from '../../Componest/Catalogos/CatSistemas/DTO/DTOActualizarContrasena';
import { ControlContrasena } from '../../Componest/Catalogos/CatSistemas/DTO/DTOControlContrasena';
import { EmpleadoMasterDto } from '../../Componest/Catalogos/CatSistemas/DTO/EmpleadoMasterDto';
import { ReporteControlContrasena } from '../../Componest/Catalogos/CatSistemas/DTO/ReporteControlContrasena';
import { CatTipoContrasenaDto } from '../../Componest/Catalogos/CatSistemas/DTO/DTOCatTipoContrasena';
import { CatTipoContrasenaRequestDto } from '../../Componest/Catalogos/CatSistemas/DTO/DTOCatTipoContrasena';
import {
    ControlContrasenaGeneral,
    ActualizarContrasenaGeneralDto
} from '../../Componest/Catalogos/CatSistemas/DTO/DTOActualizarContrasenasGenerales';




 class ControlContrasenasServices {

            
        GetByEmpleado(numEmpleado: string) {
                    return http.get<ControlContrasena[]>(
                        `/ControlContrasenas/GetByEmpleado/${numEmpleado}`
                    );
                }

                GetAllByEmpleado() {
                    return http.get<ControlContrasena[]>(
                        `/ControlContrasenas/GetAllByEmpleado`
                    );
                }

                GetReporteControlContrasenas(
                    fechaInicio?: string,
                    fechaFin?: string,
                    estatus: string = 'TODOS'
                ) {
                    return http.get<ReporteControlContrasena[]>(
                        `/ControlContrasenas/Reporte`,
                        {
                            params: {
                                fechaInicio: fechaInicio || null,
                                fechaFin: fechaFin || null,
                                estatus
                            }
                        }
                    );
                }

            
                
            
                // 🔹 INSERT / UPDATE contraseña
                ActualizarContrasena(data: ActualizarContrasenaDto) {
                    return http.post(
                        `/ControlContrasenas/Actualizar`,
                        data
                    )
                }

                // 🔹 ELIMINAR contraseña
                EliminarContrasena(numEmpleado: string, tipoContrasena: string) {
                    return http.delete(
                        `/ControlContrasenas/Eliminar/${numEmpleado}/${encodeURIComponent(tipoContrasena)}`
                    )
                }


                GetEmpleadosMaster() {
                return http.get<EmpleadoMasterDto[]>(
                    `/ControlContrasenas/EmpleadosMaster`
                );
                }

                                GetTiposContrasena(soloActivos: boolean = true) {
                    return http.get<CatTipoContrasenaDto[]>(
                        `/ControlContrasenas/TiposContrasena`,
                        {
                            params: { soloActivos }
                        }
                    );
                }

                InsertarTipoContrasena(data: CatTipoContrasenaRequestDto) {
    return http.post(
        `/ControlContrasenas/TiposContrasena`,
        {
            ...data,
            nombre: data.nombre?.trim().toUpperCase()
        }
    );
}

ActualizarTipoContrasena(id: number, data: CatTipoContrasenaRequestDto) {
    return http.put(
        `/ControlContrasenas/TiposContrasena/${id}`,
        {
            ...data,
            nombre: data.nombre?.trim().toUpperCase()
        }
    );
}

                DesactivarTipoContrasena(id: number) {
                    return http.delete(
                        `/ControlContrasenas/TiposContrasena/${id}`
                    );
                }

                ActivarTipoContrasena(id: number) {
                    return http.put(
                        `/ControlContrasenas/TiposContrasena/${id}/Activar`,
                        {}
                    );
                }



                GetAllContrasenasGenerales() {
    return http.get<ControlContrasenaGeneral[]>(
        `/ControlContrasenasGenerales/GetAll`
    );
}

GetContrasenasGeneralesByNombre(nombre: string) {
    return http.get<ControlContrasenaGeneral[]>(
        `/ControlContrasenasGenerales/GetByNombre/${encodeURIComponent(nombre)}`
    );
}

ActualizarContrasenaGeneral(data: ActualizarContrasenaGeneralDto) {
    return http.post(
        `/ControlContrasenasGenerales/Actualizar`,
        {
            ...data,
            nombre: data.nombre?.trim().toUpperCase(),
            tipoContrasena: data.tipoContrasena?.trim().toUpperCase()
        }
    );
}

EliminarContrasenaGeneral(nombre: string, tipoContrasena: string) {
    return http.delete(
        `/ControlContrasenasGenerales/Eliminar/${encodeURIComponent(nombre)}/${encodeURIComponent(tipoContrasena)}`
    );
}

GetReporteControlContrasenasGenerales(
    fechaInicio?: string,
    fechaFin?: string,
    estatus: string = 'TODOS'
) {
    return http.get(
        `/ControlContrasenasGenerales/Reporte`,
        {
            params: {
                fechaInicio: fechaInicio || null,
                fechaFin: fechaFin || null,
                estatus
            }
        }
    );
}



}

export default new ControlContrasenasServices();
